import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";
import Img247 from "../../../assets/service/24-7.svg";
import { useTranslation } from "react-i18next";

const TwentyFourSevenService = () => {
    const { t } = useTranslation();
    const description = t("service_pages.twenty_four_seven_service.description");
    // Using a fallback empty array if translations are missing to avoid crashes
    const features = t("service_pages.twenty_four_seven_service.features", { returnObjects: true }) || [];
    const highlights = t("service_pages.twenty_four_seven_service.highlights", { returnObjects: true }) || [];
    const steps = t("service_pages.twenty_four_seven_service.steps", { returnObjects: true }) || [];
    const faqs = t("service_pages.twenty_four_seven_service.faqs", { returnObjects: true }) || [];

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "24/7 Immigration Service",
        description,
        provider: {
            "@type": "LocalBusiness",
            name: "Citizen Hub",
            telephone: "+1 3108802133",
            email: "info@citizenhub.com",
        },
    };

    return (
        <ServiceDetailLayout
            title={t("service_pages.twenty_four_seven_service.title")}
            subtitle={t("service_pages.twenty_four_seven_service.subtitle")}
            description={description}
            features={features}
            highlights={highlights}
            steps={steps}
            faqs={faqs}
            imageSrc={Img247}
            imageAlt="24/7 immigration support"
            canonicalUrl="https://citizenhub.com/services/24-7-service"
            structuredData={structuredData}
        />
    );
};

export default TwentyFourSevenService;
